import { useTranslation } from 'react-i18next'

import { CaretRightIcon, WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, FormatNumber, Text } from '@reveni-io/reveni-ui'

import SizingIssuesTooltip from '../SizingIssuesTooltip/SizingIssuesTooltip'
import SizingTooltip from '../SizingIssuesTooltip/SizingTooltip/SizingTooltip'
import * as Styles from './styles'

const Variant = ({
  variant,
  onClick,
  showAmounts = true,
  salesOrdersDataActivated,
  sizeRecommendationsActivated = false,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Styles.Container onClick={onClick}>
      <Styles.SideContainer>
        <Text type="bodyMRegular" color={theme.colors.text.subtle} customStyles={{ minWidth: '20px' }}>
          #{variant?.index}
        </Text>
        <Styles.ProductImage
          src={variant?.variant_image_url || variant?.image_url || '/images/placeholderImg.png'}
          alt={variant?.name || variant?.title}
        />
        <Styles.SkuAndVariantContainer>
          <Text type="titleS">{variant?.name || variant?.title}</Text>
          <Text type="allCapsS" color={theme.colors.text.subtle}>
            {variant?.sku}
          </Text>
          <Text type="bodySRegular">{variant?.options && Object.values(variant?.options).join(' · ')}</Text>
          {sizeRecommendationsActivated && variant?.has_size_recommendation && (
            <SizingTooltip
              title={
                <SizingIssuesTooltip
                  recommendation={variant?.recommendation}
                  recommendationGlobal={variant?.recommendation_global}
                />
              }
            >
              <Styles.ChipWrapper>
                <Chip
                  label={t('Problemas de talla')}
                  Icon={WarningIcon}
                  backgroundColor={theme.colors.warning.surface}
                  color={theme.colors.warning.onSurface}
                />
              </Styles.ChipWrapper>
            </SizingTooltip>
          )}
        </Styles.SkuAndVariantContainer>
      </Styles.SideContainer>
      {showAmounts && (
        <Styles.SideContainer>
          {salesOrdersDataActivated && (
            <Styles.Total type="bodyMRegular">
              <FormatNumber style="decimal">{variant?.sales}</FormatNumber>
            </Styles.Total>
          )}
          <Styles.Total type="bodyMRegular">
            <FormatNumber style="decimal">{variant?.count}</FormatNumber>
          </Styles.Total>
          <Styles.Total type="bodyMRegular">
            <FormatNumber style="percent">{variant?.percentage}</FormatNumber>
          </Styles.Total>
          <Styles.NavigationContainer>
            {typeof onClick === 'function' && <CaretRightIcon size={24} />}
          </Styles.NavigationContainer>
        </Styles.SideContainer>
      )}
    </Styles.Container>
  )
}

export default Variant
